import { CboRole } from '@cbo/shared-library';
import { User } from '../models/User';

const checkUserRoleForEmployment = (user: User): boolean => {
  const userRoleToCheck = CboRole.MANAGED_EMPLOYEE_GRANT;
  const userRoles = user.bslAuth?.roles || [];

  return userRoles.includes(userRoleToCheck);
};

export default checkUserRoleForEmployment;
